module.exports = __webpack_public_path__ + "static/img/new_pl5.158656a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/new_pl5.png
// module id = eI+r
// module chunks = 101